import React from "react";
import {
	ClassNameMap,
	TextField
} from "@mui/material";
import { Controller } from "react-hook-form";

import {
	commonErrorParameters,
} from "./fields";

import {
	alpha,
	Theme,
} from "@mui/material/styles";

import {
	withStyles
} from "@mui/styles";

interface ZPlayFormFieldProps {
	name: string,
	minValue?: number,
	maxValue?: number,
	label: string,
	control: any,
	trigger: any,
	formState: any,
	disabled?: boolean,
	required?: boolean,
	classes: ClassNameMap<"root">,
	type?: string,
	startAdornment?: React.ReactNode,
	endAdornment?: React.ReactNode,
	onChange?: (data: string) => string,
	onBlur?: (data: string) => string,
}

const styles = (theme: Theme) => ({
	root: {
		"& .MuiFilledInput-root": {
			overflow: "hidden",
			borderRadius: "0px",
			backgroundColor: "#FFFFFF",
			transition: theme.transitions.create([
				"border-color",
				"background-color",
				"box-shadow",
			]),
			"&:hover": { backgroundColor: "#FFFFFF", },
			"&.Mui-focused": {
				backgroundColor: "#FFFFFF",
				boxShadow: `${alpha("#000000", 0.25)} 0 0 0 2px`,
				borderColor: "#000000",
			}
		}
	}
});

class ZPlayFormField extends React.Component<ZPlayFormFieldProps, {}>
{
	static defaultProps = {
		required: false,
		variant: "standard",
		type: "text",
	};

	render() {

		const { classes } = this.props;
		const maxValue = this.props.maxValue;
		const minValue = this.props.minValue;
		return (<Controller
			name={this.props.name}
			control={this.props.control}
			defaultValue=""
			render={({ field }) => (<TextField
				{...field}
				{...commonErrorParameters(this.props.name, this.props.formState)}
				required={this.props.required}
				className={classes.root}
				disabled={this.props.disabled || this.props.formState.isSubmitting}
				label={this.props.label}
				variant="filled"
				size="small"
				margin="dense"
				fullWidth
				type={this.props.type}
				InputProps={{
					inputProps: { min: minValue, max: maxValue },
					startAdornment: this.props.startAdornment,
					endAdornment: this.props.endAdornment,
				}}
				onChange={({ target: { value } }) => {

					const newValue = this.props.onChange?.(value) || value;
					field.onChange(newValue);
					this.props.trigger(this.props.name);
				}}
				onBlur={({ target: { value } }) => {
					const newValue = this.props.onBlur?.(value) || value;
					field.onChange(newValue);
					this.props.trigger(this.props.name);
				}}
			/>)}
		/>);
	}
}

export default withStyles(styles)(ZPlayFormField);
